// @flow
import React from 'react'
import { StyledOl, StyledLi, StyledUl } from '../StyledElements'

const PleaseNoteText = () => (
  <StyledOl>
    <StyledLi>
      You confirm that the information provided in this application form is true, accurate and not
      misleading.
    </StyledLi>
    <StyledLi>
      {`You will be charged a one-off joining fee (the "Membership Joining Fee") in
        order to make this application. The Membership Joining Fee is non-refundable.`}
    </StyledLi>
    <StyledLi>
      {`You will be charged a Holding Deposit which is equivalent to one week's Licence
        Fee (the "Holding Deposit"). Once you sign your Membership Agreement, you will
        be required to pay the first instalment of your Licence Fee and the Security
        Bond. The Security Bond will be held on trust for the Member in a separate
        designated account by The Collective until the end of the Membership Period.`}
    </StyledLi>
    <StyledLi>
      The Holding Deposit will only be repaid to you in full if in our sole discretion, we decide
      after receiving your verification documents (which for the avoidance of doubt must be received
      by us not later than 10 days from completion of this application form), not to enter into the
      membership agreement with you.
    </StyledLi>
    <StyledLi>
      If your application is successful and you enter into a Membership Agreement with us, your
      Holding Deposit will be deducted from the first instalment of your Licence Fee.
    </StyledLi>
    <StyledLi>
      You will have 10 days from completing this application form to submit the verification
      documents requested. If you do not submit these documents within 10 days of submitting this
      application form, you will lose the Membership Joining Fee. In the event that your move-in
      date is less than 10 days after completing this form, you will need to submit the verification
      documents at least one day before your move-in date, otherwise we shall be entitled to cancel
      your application and retain the Membership Joining Fee and Holding Deposit.
    </StyledLi>
    <StyledLi>
      Salary threshold is 2 times your annual Licence Fee. If you do not meet the salary thresholds
      or credit score, you have three options:
      <StyledOl>
        <StyledLi>
          Pay an amount equal to 2 weeks licence fee as a Security Bond, if you find a UK based
          guarantor that meet the salary thresholds
        </StyledLi>

        <StyledLi>
          Pay an amount equal to 2 weeks Licence Fee as a Security Bond, if you pay the entire
          Licence Fee upfront
        </StyledLi>
        <StyledLi>
          Pay an amount equal to 5 weeks Licence Fee as a Security Bond to allow a monthly licence
          fee payment option
        </StyledLi>
      </StyledOl>
    </StyledLi>

    <StyledLi>
      If you choose option 1 you must ensure that your guarantor lives in the UK and they will be
      required to provide any verification documents as requested. You authorise us to conduct
      credit checks on you and your guarantor for the purpose of this application.
    </StyledLi>
    <StyledLi>
      You confirm that the annual income which you have stated in this application form is correct.
    </StyledLi>
    <StyledLi>
      By submitting the application form, you agree for us to use your details to conduct a credit
      check using Credit Safe.
    </StyledLi>
    <StyledLi>
      If you submit this application form and fail to pass your credit check, your application will
      be cancelled, and the Membership Joining Fee will be repaid to you.
    </StyledLi>
    <StyledLi>
      The Membership Joining Fee is non-refundable in any circumstance other than as described above
      in clause 11. If you decide, after submission of this application form, not to enter into the
      Membership Agreement for any reason whatsoever, the Membership Joining Fee will not be repaid
      to you.
    </StyledLi>
    <StyledLi>
      <strong>Cancellation policy</strong>
    </StyledLi>
    <StyledUl>
      <StyledLi>
        The Membership Joining Fee and the Holding Deposit are non-refundable should you decide to
        cancel your application before entering into a Membership Agreement with us. By submitting
        the application form, you agree for us to use your details to conduct a credit check using
        credit.
      </StyledLi>

      <StyledLi>
        We are permitted to cancel you application if you fail to pass the credit check. In this
        circumstance, the Membership Joining Fee and the Holding Deposit will be refunded back to
        you.
      </StyledLi>
    </StyledUl>
  </StyledOl>
)

export default PleaseNoteText



// WEBPACK FOOTER //
// ./src/containers/SecureRoom/components/PleaseNoteText.js